import React from 'react';
import { Button } from '@carnica/ui-kit';
import { IconBurgerMenu } from '@carnica/graphics';
import classNames from 'classnames/bind';
import { Metric } from "../../metric";
import { HeaderThemeView } from "../../store/slices/layout";
import style from "./styles.pcss";
var cn = classNames.bind(style);
export var Menu = function Menu(_ref) {
  var toggleModalMenu = _ref.toggleModalMenu,
    headerTheme = _ref.headerTheme;
  return /*#__PURE__*/React.createElement(Metric, {
    asChild: true,
    data: "menu",
    events: {
      headerMetric: ['handleTopIconClick']
    },
    mode: "click",
    "data-t-id": "components-Menu"
  }, /*#__PURE__*/React.createElement(Button, {
    "aria-label": "\u043E\u0442\u043A\u0440\u044B\u0442\u044C \u0431\u043E\u043A\u043E\u0432\u043E\u0435 \u043C\u0435\u043D\u044E",
    className: cn('burger-menu'),
    iconLeft: IconBurgerMenu,
    onClick: function onClick() {
      return toggleModalMenu();
    },
    onlyIcon: true,
    size: "m",
    view: HeaderThemeView[headerTheme],
    "data-t-id": "components-Menu"
  }));
};